import { forwardRef } from 'react'

const Radio = forwardRef(function Radio(
  { checked, onChange, label, name, value, disabled = false, ...rest },
  ref
) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        fontFamily: 'var(--font-body)',
        fontSize: 13,
        color: 'var(--olv-text-primary)',
      }}
    >
      <span
        style={{
          width: 16,
          height: 16,
          borderRadius: '50%',
          background: 'rgba(12,12,20,0.6)',
          border: `1px solid ${checked ? 'var(--olv-purple)' : 'rgba(255,255,255,0.12)'}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 200ms var(--ease-standard)',
          flexShrink: 0,
        }}
      >
        {checked && (
          <span
            style={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              background: 'var(--olv-purple)',
            }}
          />
        )}
      </span>
      <input
        ref={ref}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
        {...rest}
      />
      {label && <span>{label}</span>}
    </label>
  )
})

export default Radio
